import React from "react";
import { FaRegUser } from "react-icons/fa";
import { FaRegCirclePlay } from "react-icons/fa6";
import { IoCameraOutline } from "react-icons/io5";
import { MdOutlineCalendarMonth, MdOutlineLocationOn } from "react-icons/md";
import { TbClock } from "react-icons/tb";
import { Link } from "react-router-dom";

function EventDetail() {
  return (
    <div>
      <div className="p-5 bg-white">
        <h3 className="h3Title mb-4">Customer Dwell Time</h3>
        <div className="customerDwellTime">
          <div className="itemsBox">
            <span>
              <IoCameraOutline size={20} />
            </span>
            <div className="">
              <h5>Camera</h5>
              <h3>Cash Counter</h3>
            </div>
          </div>

          <div className="itemsBox">
            <span>
              <MdOutlineLocationOn size={20} />
            </span>
            <div className="">
              <h5>Location</h5>
              <h3>Cashier Area</h3>
            </div>
          </div>

          <div className="itemsBox">
            <span>
              <MdOutlineCalendarMonth size={20} />
            </span>
            <div className="">
              <h5>Tracking</h5>
              <h3>11 Jul, 2025 - 20 Jul, 2025</h3>
            </div>
          </div>
        </div>
      </div>
      <div className="p-5 border-top">
        <div className="d-flex mb-4">
          <h4 className="h6Title">Customer Analyses</h4>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <div className="customerAnalysesGrid">
              <div className="itemsBox">
                <span><FaRegUser size={18} /></span>
                <div className="">
                  <h5>Total Customers</h5>
                  <div className="customer">
                    800<p>Customers</p>
                  </div>
                </div>
              </div>

              <div className="itemsBox">
                <span><TbClock size={18} /></span>
                <div className="">
                  <h5>Total Customers</h5>
                  <div className="customer">
                    800<p>Customers</p>
                  </div>
                </div>
              </div>

              <div className="itemsBox">
                <span><TbClock size={18} /></span>
                <div className="">
                  <h5>Total Customers</h5>
                  <div className="customer">
                    800<p>Customers</p>
                  </div>
                </div>
              </div>

              <div className="itemsBox">
                <span><TbClock size={18} /></span>
                <div className="">
                  <h5>Total Customers</h5>
                  <div className="customer">
                    800<p>Customers</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6"></div>
        </div>

        <div className="mt-5 cstTableCls">
          <table className="table rounded-3 border">
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>Customers #</th>
                <th>Time Length</th>
                <th>Entered</th>
                <th>Exited </th>
                <th>Video</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <img src="../images/camImg.png" />
                </td>
                <td>#01</td>
                <td>01 Minutes </td>
                <td>07/11/2024, 11:05:58AM</td>
                <td>07/11/2024, 11:05:58AM</td>
                <td>
                  <Link className="videoLink">
                    <FaRegCirclePlay size={22} /> Play Video
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default EventDetail;
